class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-recommendations-list]');
    this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
    this.refresh();
  }

  disconnectedCallback() {
    if (this.unsubscribeCartUpdate) this.unsubscribeCartUpdate();
  }

  async refresh() {
    try {
      const cartResponse = await fetch(`${routes.cart_url}.json`);
      const cart = await cartResponse.json();

      if (!cart.items.length) {
        this.hidden = true;
        return;
      }

      const lastItem = cart.items[cart.items.length - 1];
      const cartProductIds = new Set(cart.items.map((item) => item.product_id));

      const recommendationsResponse = await fetch(
        `${routes.root_url}recommendations/products.json?product_id=${lastItem.product_id}&limit=8&intent=related`
      );
      const data = await recommendationsResponse.json();
      const products = (data.products || []).filter((product) => !cartProductIds.has(product.id)).slice(0, 4);

      if (!products.length) {
        this.hidden = true;
        return;
      }

      this.renderProducts(products);
      this.hidden = false;
    } catch (e) {
      this.hidden = true;
    }
  }

  renderProducts(products) {
    if (!this.list) return;

    this.list.innerHTML = products
      .map((product) => {
        const image = product.featured_image || (product.images && product.images[0]) || '';
        const imageUrl = image ? this.resizeImage(image, 160) : '';
        const title = this.escapeHtml(product.title);

        return `
          <li class="cart-recommendations__item">
            <a href="${this.escapeHtml(product.url)}" class="cart-recommendations__link">
              ${
                imageUrl
                  ? `<img src="${imageUrl}" alt="${title}" width="80" height="80" loading="lazy" class="cart-recommendations__image">`
                  : ''
              }
              <span class="cart-recommendations__title">${title}</span>
              <span class="cart-recommendations__price">${this.formatMoney(product.price)}</span>
            </a>
          </li>
        `;
      })
      .join('');
  }

  resizeImage(url, width) {
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, `_${width}x$1$2`);
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  formatMoney(cents) {
    const amount = cents / 100;
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return 'Rs. ' + Math.round(amount);
    }
  }
}

customElements.define('cart-recommendations', CartRecommendations);
